import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../services/snackbar.service';
import { ClientService } from '../services/client.service';

@Component({
  selector: 'app-form-client',
  templateUrl: './form-client.component.html',
  styleUrls: ['./form-client.component.css']
})
export class FormClientComponent {

  form: FormGroup;
  submitted = false;

  readonly formImageUrl = 'https://comprasinteligentes.co/cchayuelos/Formulario.png';
  readonly formImageMobileUrl = 'https://comprasinteligentes.co/cchayuelos/Formulario_mobile.png';
  readonly thanksImageUrl = 'https://comprasinteligentes.co/cchayuelos/Agradecimiento.png';
  readonly thanksImageMobileUrl = 'https://comprasinteligentes.co/cchayuelos/Agradecimiento_mobile.png';

  constructor(private fb: FormBuilder,
              private snackBarService:SnackbarService,
              private clientService:ClientService
  ) {
    window.location.href = 'https://centrocomercial.biccrm.com/hayuelos/form-client';
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      cedula: ['', Validators.required],
      celular: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      correo: ['', [Validators.required, Validators.email]]
    });
  }

  splitName(fullName: string): { nombre1: string, nombre2: string, apellido1: string, apellido2: string } {
    const parts = fullName.trim().split(/\s+/);
    switch (parts.length) {
      case 2:
        return { nombre1: parts[0], nombre2: '', apellido1: parts[1], apellido2: '' };
      case 3:
        return { nombre1: parts[0], nombre2: '', apellido1: parts[1], apellido2: parts[2] };
      default:
        return { nombre1: parts[0], nombre2: parts[1], apellido1: parts[2], apellido2: parts.slice(3).join(' ') };
    }
  }

  onSubmit(): void {
    if (this.form.valid) {
      const { nombre1, nombre2, apellido1, apellido2 } = this.splitName(this.form.value.nombre);      
      const bodyConsult = {
        documento:this.form.value.cedula,
      }
      this.clientService.getClient(bodyConsult).subscribe({
        next:(res:any)=>{
          const edit = res.result.length > 0 ? true : false;
          const data = res.result.length > 0 ? res.result[0] : null;
          const body:any = {
          personalForm: {
            nombre1 : data?.NOMBRE1 ??nombre1,
            nombre2 : data?.NOMBRE2 ??nombre2,
            apellido1 : data?.APELLIDO1 ??apellido1,
            apellido2 : data?.APELLIDO2 ??apellido2,
            documento: data?.DOCUMENTO ?? this.form.value.cedula,
            telefono2: this.form.value.celular,
            email: this.form.value.correo,
            idGenero:data?.IDSEXO ?? 1,
            idTipoDocumento:data?.IDTIPODOCUMENTO ?? 0,
            fechaNacimiento:data?.FECHANACIMIENTO ?? new Date(1990, 0, 1),
            idCiudadResidencia:data?.IDCIUDADRESIDENCIA ?? 3,
            direccionResidencia: data?.DIRECCIONRESIDENCIA ?? '',
            telefono1: data?.TELEFONO1 ?? '',
            placa1: data?.PLACA1 ?? '',
            placa2: data?.PLACA2 ?? '',
            estrato: data?.ESTRATO ?? null,
            tipoGrupo: data?.TIPOGRUPO ?? '',
            tipoCliente: data?.TIPOCLIENTE ?? '',
            barrioResidencia: data?.BARRIORESIDENCIA ?? '',
          },
          secondaryForm:{
            idOcupacion: data?.IDOCUPACION ?? 0,
            idEmisora: data?.IDEMISORA ?? 0,
            idEstadoCivil: data?.IDESTADOCIVIL ?? 0,
            idNivelEstudio: data?.IDNIVELESTUDIO ?? 0,
            idProfesion: data?.IDPROFESION ?? 0,
            idPeriodico: data?.IDPERIODICO ?? 0,
          },
          edit:edit,
          usuario:'paginaweb',
          idCliente:data?.IDCLIENTE ?? null
        };        
          this.clientService.insertOrEditClient(body).subscribe({
            next:(res:any)=>{
              this.snackBarService.show("success","El cliente ha sido registrado");
              this.submitted = true;
            },
            error:err=>{
              this.snackBarService.show("error",err.message);
            }
          })
        },
        error:err=>{
          this.snackBarService.show('error',err.message);
        }

      })      
    } else {
      this.form.markAllAsTouched();
      this.snackBarService.show("error","Debe digitar todos los campos");
    }
  }

  reset(): void {
    this.form.reset();
    this.submitted = false;
  }
}
